// extracted by mini-css-extract-plugin
export var typingIndicator = "_lz-0";